import { render, staticRenderFns } from "./PendingEditRequestStatusValues.vue?vue&type=template&id=623b4934&"
import script from "./PendingEditRequestStatusValues.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestStatusValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports